// Static content sourced from dnadigital.in + audit brief
export const LOGO = "/dna-logo.png";

export const CALENDLY = "https://calendly.com/dj-dnadigital/1on1consultation?back=1";
export const PARENT_SITE = "https://www.dnadigital.in";
export const ECOM_SITE = "https://www.amazonads.co.in";
export const DIGIMONK_SITE = "https://demo.digimonk.ai";

export const ABOUT = {
  overline: "About DNA Digital",
  heading: "Born in 2017. Built to breathe life into brands.",
  paragraphs: [
    "DNA Digital started as a spark from the mind of our founder, DJ — and grew into a wildfire of creativity across the globe. From humble beginnings we've expanded our playground to Dubai, South Africa, the USA and the UK.",
    "We're not just another digital agency. We're the team behind some of the world's most memorable brands, across healthcare, retail, aerospace and beyond. Our secret sauce is a mix of innovation, strategy and a healthy dash of fun.",
    "Just like DNA, we build strong, resilient and adaptable digital identities that stand the test of time — brands we don't just create, but breathe life into.",
  ],
  stats: [
    { value: "2017", label: "Founded" },
    { value: "5", label: "Countries" },
    { value: "100+", label: "Brands scaled" },
  ],
};

export const IMAGES = {
  team: "https://images.unsplash.com/photo-1758691737124-05c5bffe46f0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxkaWdpdGFsJTIwbWFya2V0aW5nJTIwdGVhbSUyMG1vZGVybiUyMG9mZmljZXxlbnwwfHx8fDE3ODU1NjU0MjN8MA&ixlib=rb-4.1.0&q=85",
  warehouse: "https://images.unsplash.com/photo-1684695749267-233af13276d0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHw0fHxlY29tbWVyY2UlMjB3YXJlaG91c2UlMjBib3hlc3xlbnwwfHx8fDE3ODU1NjU0MjN8MA&ixlib=rb-4.1.0&q=85",
};

export const STATS = [
  { value: "₹250Cr+", label: "Ad spend managed" },
  { value: "11.4X", label: "Peak ROAS delivered" },
  { value: "9", label: "Years scaling brands" },
  { value: "5", label: "Countries, one team" },
];

export const SERVICES = [
  { n: "01", title: "Performance Marketing", desc: "AI-assisted acquisition across Meta, Google & YouTube — engineered for high-intent leads at the lowest possible CPA." },
  { n: "02", title: "Amazon & Ecommerce Ads", desc: "Full-funnel marketplace growth — DSP, Sponsored Ads, listing & storefront optimisation that compounds revenue." },
  { n: "03", title: "Data-Driven Creative", desc: "Creative that sells on sight. High CTR, strong quality scores, CPCs that drop month on month." },
  { n: "04", title: "Video Production & Editing", desc: "From raw concept to final cut — direction, shoot, editing and motion graphics under one roof." },
  { n: "05", title: "Landing Pages & CRO", desc: "Conversion-first pages built, tested and obsessively optimised using GA4 and behavioural psychology." },
  { n: "06", title: "CRM & Retention", desc: "WhatsApp sequences, email flows and nurture systems that close the loop on every lead." },
  { n: "07", title: "Social & Brand Building", desc: "Content calendars, shoot-ready briefs and community — backed by performance data." },
  { n: "08", title: "Agentic AI Automation", desc: "Autonomous AI agents for sales, support and ops. Intelligent workflows that run 24/7." },
];

export const MANIFESTO = [
  { n: "01", text: "Your dashboard is green. Your bank account disagrees." },
  { n: "02", text: "ROAS can look healthy while your margins quietly collapse." },
  { n: "03", text: "CPL can fall while lead quality gets steadily worse." },
  { n: "04", text: "Revenue can grow while your CAC, refunds and cash-flow problems grow with it." },
];

export const PROCESS = [
  { n: "01", title: "The Briefing", desc: "We map your business model, current numbers, biggest concerns and the goals you're chasing." },
  { n: "02", title: "Read-Only Access", desc: "You share access only to the platforms relevant to the problem — ads, analytics, CRM." },
  { n: "03", title: "The Investigation", desc: "Our senior teams examine acquisition, creative, funnels, tracking and unit economics." },
  { n: "04", title: "The Founder Readout", desc: "We show what's working, what's misleading you, where money leaks and what to fix next." },
];

export const CASES = [
  { client: "Mamaearth", metric: "₹2L → ₹2.6Cr", detail: "Monthly revenue scaled. AOV ₹598 → ₹1,500. CTR 0.7 → 2.8 over a 3-year partnership.", color: "var(--dna-orange)" },
  { client: "Dot & Key", metric: "28.5X", detail: "Account performance improvement. Spend scaled ₹40L → ₹1.2Cr/mo with 175% revenue growth.", color: "var(--dna-pink)" },
  { client: "Vahdam Teas", metric: "1.2X → 3.8X", detail: "Fixed a broken international account across US, UK, India & UAE campaigns.", color: "var(--dna-blue)" },
  { client: "STIM", metric: "ROAS 11.4", detail: "Improved ROAS to 8 in 3 months, then elevated to 11.4 over the following 8 months.", color: "var(--dna-orange)" },
  { client: "Kama Ayurveda", metric: "6X scale", detail: "Premium AOV maintained while scaling daily spend 6X for luxury Ayurvedic skincare.", color: "var(--dna-pink)" },
  { client: "Gynoveda", metric: "2X CTR", detail: "Complex health funnel across fertility, PCOS and period care. CTR 2X above category avg.", color: "var(--dna-blue)" },
];

export const TESTIMONIALS = [
  { name: "Viren Khuller", role: "Director, STIM", quote: "They helped us scale performance significantly, improving ROAS to 8 in the first 3 months and to 11.4 over the following 8 months. A team that combined strategy with action." },
  { name: "Jérôme de Guigné", role: "e-Comas, Germany", quote: "DJ with the DNA crew is a great, friendly and efficient team — a very 'sharp' swiss knife of digital media practices. We'd certainly recommend them." },
  { name: "Dheeraj Khatter", role: "Founder & CEO, MyMobiForce", quote: "Highly professional and well-structured. They deeply understood our business and translated it into an effective, consistently high-quality marketing plan." },
  { name: "Justice Chikomba", role: "Founder, Analytics Hive", quote: "DNA catapulted the visibility of our brand to levels we never imagined, and we started getting higher-quality inbound leads that enriched our pipeline." },
  { name: "Satyam Garg", role: "ActionCoach India", quote: "Thanks to DNA's expertise in paid and organic, our coaching firm saw a remarkable boost in visibility and engagement. A game-changer." },
];

export const PHONES = [
  { country: "India", number: "+91 9873 362 362" },
  { country: "UAE", number: "+971 50 945 4414" },
  { country: "USA", number: "+1 310 770 7705" },
  { country: "UK", number: "+44 7868 811863" },
];

export const ADDRESS = "WeWork Berger Delhi One, Floor 19, C-001/A2, Sector 16B, Noida, Uttar Pradesh 201301";

export const PARTNERS = [
  { name: "Meta Business Partner", logo: "/partners/meta.png", url: "https://www.facebook.com/business/partner-directory/search?solution_type=campaign_management&id=5996999810352810&section=overview" },
  { name: "Google Partner", logo: "/partners/google.png", url: "https://www.google.com/partners/agency?id=6149486763" },
  { name: "Amazon Ads Verified Partner", logo: "/partners/amazon.png", url: "https://advertising.amazon.com/partners/directory/details/amzn1.ads1.ma1.43nrsaw1n7hzojqbw13e9mycx/DNA-Digital/" },
  { name: "Shopify Partners", logo: "/partners/shopify.png", url: "https://www.shopify.com/partners" },
];

export const BUSINESS_TYPES = ["D2C / E-commerce", "Amazon / Marketplace Seller", "EdTech / Online Education", "Lead Generation", "SaaS", "Services", "Other"];
export const REVENUE = ["Below ₹10L", "₹10L – ₹30L", "₹30L – ₹1Cr", "₹1Cr – ₹5Cr", "Above ₹5Cr"];
export const AD_SPEND = ["Below ₹2L", "₹2L – ₹10L", "₹10L – ₹30L", "₹30L – ₹1Cr", "Above ₹1Cr"];
